import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import Download from 'assets/icon/Download.svg';

import HoverImage from 'react-hover-image/build';
import { Button, Card, CardBody, Modal, ModalBody, ModalHeader, ModalFooter, Row, Col } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck, dateFormat, datetimeformate } from 'utils/columns';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import { dateFormate } from 'utils/columns';
import { toast } from 'react-toastify';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import useAxios from 'hooks/useAxios';
import collapse from 'assets/icon/collapse-icon.svg';
import collapseclose from 'assets/icon/collapse-icon-close.svg';
import Filters from 'components/Filters';
import collapseexpand from 'assets/icon/collapse-expand.svg';
import closeicon from 'assets/icon/close-icon.svg';


import HistoryIcon from "assets/icon/icon-icon-options-view-claims.svg";
import HistoryHoverIcon from "assets/icon/icon-icon-options-view-claims_hover.svg";
import Loader from 'components/Loader';

let tableDataBackup = []
let rowForEdit = {};

const CaseManagement = (props) => {

  const {
    manvalConfigedit,
    manvalConfig,
    manvalPharmacy,
    onExport,
    handleExport,
    collapseSider,
    toggleSider,
    manval,
    data,
    onSearch,
    filters,
    totalSize,
    onPageChange,
    setFilterShow,
    filtershow,
    fetchConfiguration,
    startPage,
    setStartPage,
    selectedValues,
    setSelectedValues,
    sort,
    setSort,
    refetch,
    loading,
    onSearchColumnFilters = () => "",
    ceid,
    toogleview,
    settoogleView,
    selectedRow,
    setselectedRow,
    resetfilter,
    setAttachment,
    caseAttachment

  } = props;

  tableDataBackup = data
  const [tableData, setTableData] = useState(tableDataBackup);
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);


  // const [selectedRow, setselectedRow] = useState({});
  const [date, setDate] = useState("")
  const [state, updateState] = useState({
    filters: filters,
  });
  // console.log(filters, "filters")
  const API = useAxios();
  const handleConfig = async (rowData) => {
    await manvalConfig();

  }
  const handelAddCoveredEntity = async (rowData) => {
    await manvalPharmacy();

  }


  const handleEditConfig = async () => {
    await manvalConfigedit();
  }

  const handleFilterCancel = () => {
    refetch(true);
  };
  const renderEditButton = (rowData) => {
    // if (hasPermission('EDT'))
    return <Button
      className='text-primary p-0 text-decoration-none'
      color='link'
      onClick={() => handleExport(rowData)}
      title='Edit Covered Entity'
    >
      <HoverImage src={Download}
        hoverSrc={DownloadHover}
        alt='' />
    </Button>
  }
  useEffect((filter) => {
    //onSearch(filter);
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };


  const handleSearchColumnFilters = (colFilter) => {

    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };


  const editRow = (rowData, isEdit = true) => {
    let tempData = [...tableDataBackup];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.reportConfigID === rowData?.reportConfigID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    tableDataBackup = tempData;
    setTableData(tempData);
  };

  const cellRenderEdit = (rowData) => {


    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => toggle(rowData)}
        // onClick={toggle}
        title="View Case Details"
      >
        <HoverImage
          key="HistoryIcon"
          src={HistoryIcon}
          hoverSrc={HistoryHoverIcon}
          alt=""
        />
      </Button>
    );

  }

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        formatterType={formatterType}
        onChange={updateRowValue}
      />
    );
  }

  const checkvalidation = (selectedvaluesonly) => {
    if (!selectedvaluesonly.endDate) {
      toast.error('Please select End Date')
      return true
    }
    let endDate = new Date(selectedvaluesonly.endDate);
    if (isNaN(endDate)) {
      toast.error('Please select a valid End Date');
      return true;
    }
    const endDateStr = String(selectedvaluesonly.endDate)
    const [endMonth, endDay, endYear] = endDateStr.split('/');
    endDate = new Date(`${endYear}-${endMonth}-${endDay}`);
    const startDate = new Date(rowForEdit.startDate);
    if (endDate < startDate) {
      toast.error('End Date should be greater than start Date');
      return true;
    }
    const todayDate = new Date()
    if (endDate < todayDate) {
      toast.error('End Date should be Today or Future Dates');
      return true;
    }
    else {
      return false;
    }

  }


  let mainCol = [
    {
      dataField: 'edit',
      text: 'Options',
      cellRenderer: (row) => cellRenderEdit(row),
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },

    {
      dataField: 'caseNo ',
      text: 'Case Number ',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.caseNo),
    },
    {
      dataField: 'subject ',
      text: 'Subject',
      sort: false,
      width: 320,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.subject),
    },

    {
      dataField: 'productLine ',
      text: 'Product Line',
      sort: false,
      width: 200,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.productLine),
    },
    {
      dataField: 'caseReason ',
      text: 'Case Reason',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.caseReason),
    },
    {
      dataField: 'caseSubReason ',
      text: 'Case Sub Reason',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.caseSubReason),
    },
    {
      dataField: 'status ',
      text: 'Status',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.status),
    },

    // {
    //   dataField: 'priority ',
    //   text: 'Priority ',
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: 'text',
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.priority),
    // },
    {
      dataField: 'openDate',
      text: 'Opened Date/Time ',
      sort: true,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (row) => datetimeformate(row.openDate),
    },
    {
      dataField: 'lastUpdated',
      text: 'Last Updated Date/Time',
      sort: true,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (row, col) => datetimeformate(row.lastUpdated),
      //cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      edit: true
    },
    {
      dataField: 'closeDate',
      text: 'Closed Date/Time',
      sort: false,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (row, col) => datetimeformate(row.closeDate),
      //cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      edit: true
    },

    {
      dataField: 'estimatedDate',
      text: 'Estimated Complete Date',
      sort: false,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (row, col) => dateFormate(row.estimatedDate),
    },

    // {
    //   dataField: 'waitTime',
    //   text: 'Wait Time (Days)',
    //   sort: true,
    //   width: 140,
    //   show: true,
    //   inputType: 'text',
    //   hideColFilter: true,
    //   cellRenderer: (row) => cellRendererCheck(row.waitTime == 0 ? "0" : row.waitTime),
    // },

    {
      dataField: 'requestedBy',
      text: 'Requested By',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.requestedBy),
    },

    {
      dataField: 'ceNameWithOPACode',
      text: 'Covered Entity/OPAID',
      sort: false,
      width: 320,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      edit: true,
      cellRenderer: (row) => cellRendererCheck(row.ceNameWithOPACode),
    },

    // {
    //   dataField: 'serviceLine',
    //   text: 'Service Line ',
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: 'text',
    //   hideColFilter: true,
    //   edit: true,
    //   cellRenderer: (row, col) => cellRendererCheck(row.serviceLine),
    // },

  ];
  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  const handleSort = (filter, hasColFilter) => {
    setState({
      filters: filter,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
      setSort(true)
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };


  const toggle = (row) => {
      setselectedRow(row)
    // formatDateTime(row.openDate)
    // showaccountDetails();
    setModal(!modal);
    settoogleView(!toogleview)
    // caseattachments(row)
    setAttachment(row)
  }
  const toggle1 = () => {
    // formatDateTime(row.openDate)
    // showaccountDetails();
    setModal1(!modal1);
  }


  const truncateText = (htmlString = '', wordLimit = 30) => {
    if (!htmlString) return '';

    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    const plainText = tempElement.textContent || tempElement.innerText || "";

    const words = plainText.trim().split(/\s+/);
    const isTruncated = words.length > wordLimit;

    let truncated = isTruncated
      ? words.slice(0, wordLimit).join(" ") + ` <a href="#" title="Click on Expand icon on top right corner to read more." class="read-more-link">...</a>`
      : plainText;

    return truncated.replace(/\n/g, "<br>");
  };

  const caseattachments = async (row) => {
    const paylod = {}
    // paylod.caseId = "500cZ000006f8ZGQAY"
    paylod.caseId = row.caseId

    const { data } = await API.post(`/api/search/caseattachments`, paylod,)
    // console.log(data,)
    if (data) {
      setAttachment(data)
    }
  };

  return (

    <div>
      {/* {loading&&<Loader opacity={0.01}color='black'/>} */}
      <div className="d-flex justify-content-between section-devider-border pb-2">
        <h3 className='f-16 font-weight-600' style={{ color: "#702C62" }}>All Cases
          {totalSize > 0 &&
            <span className='f-18 text-primary font-weight-700 ms-1'>({totalSize})</span>}
        </h3>

        <div style={{ cursor: "pointer" }} onClick={toggleSider}>
          <img collapseSider src={!collapseSider ? collapse : collapseclose} className="" />
        </div>
      </div>


      {/* <div class="row mt-3">
        <div class="col">
          <Card className="border-0">
            <CardBody>
              <div className="d-flex justify-content-start align-items-center list-grid">
                <div className="left_info">
                  <span><img src={opencases} alt="" /></span>
                </div>
                <div className="right_info">
                  <h4>Open Cases</h4>
                  <p>12</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        <div class="col">
          <Card className="border-0">
            <CardBody>
              <div className="d-flex justify-content-start align-items-center list-grid">
                <div className="left_info">
                  <span><img src={prioritycase} alt="" /></span>
                </div>
                <div className="right_info">
                  <h4>Priority Cases</h4>
                  <p>12</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        <div class="col">
          <Card className="border-0">
            <CardBody>
              <div className="d-flex justify-content-start align-items-center list-grid">
                <div className="left_info">
                  <span><img src={resolvedcase} alt="" /></span>
                </div>
                <div className="right_info">
                  <h4>Resolved Cases</h4>
                  <p>12</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        <div class="col">
          <Card className="border-0">
            <CardBody>
              <div className="d-flex justify-content-start align-items-center list-grid">
                <div className="left_info">
                  <span><img src={closedcase} alt="" /></span>
                </div>
                <div className="right_info">
                  <h4>Closed Cases</h4>
                  <p>12</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        <div class="col">
          <Card className="border-0">
            <CardBody>
              <div className="d-flex justify-content-start align-items-center list-grid">
                <div className="left_info">
                  <span><img src={totalcase} alt="" /></span>
                </div>
                <div className="right_info">
                  <h4>Total Cases</h4>
                  <p>12</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div> */}


      <div className='table-card scroll-table position-relative border-0 rounded pt-0'
        fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}>
        {/* {loading && <Loader opacity={0.01} />} */}
        <ReactStrapTable
          id='configuration-table'
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          data={tableData}
          columns={mainCol}
          // addbutton={true}
          handelAddCoveredEntity={handelAddCoveredEntity}
          // onExport={onExport}
          onExport={handleExport}
          hidden={true}
          filters={filters}
          totalRecords={totalSize}
          pageSize={filters.pageSize}
          currentPage={filters.currentPage}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          handleSort={handleSort}
          startPage={startPage}
          setStartPage={setStartPage}
          onFilterCancel={handleFilterCancel}
          // onSearchColumnFilters={handleSearchColumnFilters}
          hasExportPermission={true}
          isConfigurationTable={true}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          showtoggle={true}
          sort={sort}
          onSearchColumnFilters={handleSearchColumnFilters}
          resetfilter={resetfilter}
          setSort={setSort}


        />
      </div>
    </div>
  )
}

export default CaseManagement